import CallToAction from './components/CallToAction';
import Description from './components/Description';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import ImageGallery from './components/ImageGallery';
import ImageTextSection from './components/ImageTextSection';
import Shapes from '../../components/Shapes';
import Title from './components/Title';
import SlotDetails from './components/SlotDetails';

function Home() {
    return (
        <div>
            <Title />
            <Description />
            <ImageTextSection />
            <CallToAction />
            <Shapes />
            <SlotDetails />
            <ImageGallery />
            <FAQ />
            <Footer />
        </div>
    )
}

export default Home;